<template>
  <div class="balanceList">
    <div class="top-block">
      <div class="top-txt" @click="isShow = !isShow">
        全部类型
        <img src="@/assets/images_member/per1 (37).png" v-if="!isShow" class="icon-arrow" alt="">
        <img src="@/assets/images_member/per1 (46).png" v-else class="icon-arrow" alt="">
      </div>
      <div class="top-list" v-if="isShow">
        <div class="item" :class="curItem === 'all' ? 'cur' : ''" @click="handleClickItem('all')">全部</div>
        <div class="item" :class="curItem === 1 ? 'cur' : ''" @click="handleClickItem(1)">收入</div>
        <div class="item" :class="curItem === 2 ? 'cur' : ''" @click="handleClickItem(2)">支出</div>
        <div class="item" :class="curItem === 'not_settle' ? 'cur' : ''" @click="handleClickItem('not_settle')">待结算</div>
      </div>
    </div>
    <div class="none-div" v-if="isNone">
      <img src="@/assets/images_member/per1 (13).png" class="none-img" alt="">
      <div class="none-txt">暂无记录哦～</div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list" offset="60">
      <div v-for="(item, index) in listData" :key="index">
        <div class="item-title">{{ item.monthText }}</div>
        <div class="item" v-for="(item_cur, index_cur) in item" :key="index_cur" @click="handleJump(item_cur)">
          <div class="txt-div">
            <div class="txt1">{{ item_cur.remarks }}</div>
            <div class="txt2">{{ item_cur.change }}</div>
          </div>
          <div class="txt-div">
            <div class="txt3">{{ item_cur.create_time }}</div>
            <div class="txt3">{{ item_cur.type_text }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { financeList } from '@/api/person'
export default {
  name: 'balanceList',
  data () {
    return {
      isShow: false,
      isNone: false,
      listData: [],
      list: [],
      loading: false,
      finished: false,
      page: 1,
      num: 10,
      curItem: ''
    }
  },
  mounted () {
  },
  methods: {
    onLoad () {
      financeList({
        page: this.page,
        num: this.num,
        type: 'money',
        not_settle: this.curType === 'not_settle' ? 1 : 0,
        pay_type: this.curType !== 'all' ? this.curType : ''
      }).then(res => {
        if (res.data.length < this.num) {
          this.finished = true
        }
        this.list = this.list.concat(res.data)
        // 加载状态结束
        this.loading = false
        if (this.list <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.page++
        this.arrChange(res.data)
      })
    },
    arrChange (returnData) {
      let arr = this.listData.length > 0 ? this.listData[this.listData.length - 1] : []
      let result = returnData.reduce((pre, next, curIdx) => {
        let nextMonthTitle = new Date(next.create_time).getFullYear() + '/' + new Date(next.create_time).getMonth()
        if (!arr.monthTitle || arr.monthTitle !== nextMonthTitle) {
          arr = []
          arr.monthText = `${new Date(next.create_time).getFullYear()}/${new Date(next.create_time).getMonth() + 1}月`
          arr.monthTitle = new Date(next.create_time).getFullYear() + '/' + new Date(next.create_time).getMonth()
          arr.push(next)
          pre.push(arr)
        } else {
          arr.push(next)
        }
        return pre
      }, [])
      this.listData = this.listData.concat(result)
    },
    handleClickItem (type) {
      this.curItem = type
      this.page = 1
      this.finished = false
      this.list = []
      this.listData = []
      this.curType = type
      // this.onLoad()
    },
    handleJump(item) {
      // this.$router.push({
      //   path: '/balanceDetail',
      //   query: {
      //     item: JSON.stringify(item)
      //   }
      // })
    }
  }
}
</script>

<style lang="less" scoped>
.balanceList {
  min-height: 100vh;
  width: 100vw;
  background-color: #1E2020;
  box-sizing: border-box;

  .top-block {
    background-color: #EDEDED;
    padding: 10px 14px;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;

    .top-txt {
      height: 34px;
      width: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
      background-color: #fff;
      font-size: 12px;
      color: #313133;
      font-weight: 500;

      .icon-arrow {
        width: 8px;
        height: 4px;
        margin-left: 8px;
      }
    }

    .top-list {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      justify-content: space-between;
      position: absolute;
      width: 100%;
      top: 52px;
      left: 0;
      height: 66px;
      padding: 0 14px;
      background-color: #EDEDED;

      .item {
        width: 80px;
        height: 38px;
        border-radius: 3px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333333;
        font-weight: 500;

        &.cur {
          background-color: #292B2A;
          color: #FFFFFF;
        }
      }
    }
  }

  .none-div {
    .none-img {
      width: 117px;
      height: 70px;
      margin-bottom: 16px;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 180px;
    }

    .none-txt {
      text-align: center;
      font-size: 16px;
      color: #999999;
      font-weight: 500;
    }
  }

  .list {
    background-color: #1E2020;
    border-radius: 6px 6px 0px 0px;
    padding: 0 14px;
    box-sizing: border-box;

    .item-title {
      background-color: #292B2A;
      height: 40px;
      padding-left: 15px;
      box-sizing: border-box;
      font-size: 12px;
      color: #999999;
      font-weight: 500;
      width: 100vw;
      margin-left: -14px;
      line-height: 40px;
    }

    .item {
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #666666;

      &:last-child {
        border: none;
      }

      .txt-div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 16px;

        .txt1 {
          font-size: 16px;
          color: #FFFFFF;
          white-space: nowrap;
          overflow: hidden;
          width: 260px;
          text-overflow: ellipsis;
        }

        .txt2 {
          font-size: 16px;
          color: #F0E1C0;
        }

        .txt3 {
          font-size: 12px;
          color: #999999;
          line-height: 8px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/balanceList.vue